import * as React from 'react';
import PropTypes from 'prop-types';
import { limuirsComponent } from 'limuirs-components';
import _ from 'lodash';

/**
 * Membership count for a node.
 *
 * @author Patricio Poratto, Adam Ayres
 */
const MembershipCount = ({ node, text, useIcon }) =>
  _.has(node, 'memberships.count') && (
    <div className="lia-membership-count">
      {useIcon && <i className="lia-fa lia-fa-user " />}
      {text.format(useIcon ? 'iconCount' : 'count', { count: node.memberships.count })}
    </div>
  );

MembershipCount.propTypes = {
  /** The node to display the membership count for */
  node: PropTypes.shape({
    members: PropTypes.shape({
      count: PropTypes.number
    }),
    // eslint-disable-next-line camelcase
    membership_type: PropTypes.string
  }).isRequired,
  /** Whether to show the lock icon; when icon is used an alternative text key is used for display the count */
  useIcon: PropTypes.bool
};

MembershipCount.defaultProps = {
  useIcon: true
};

export default limuirsComponent(module, MembershipCount);
